/**
 * Copyright 2025 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT-0
 */

export const APPROVE_DRIVER = `
  mutation ApproveDriver($driverId: ID!, $reason: String) {
    approveDriver(driverId: $driverId, reason: $reason) {
      id
      status
    }
  }
`;

export const REJECT_DRIVER = `
  mutation RejectDriver($driverId: ID!, $reason: String!) {
    rejectDriver(driverId: $driverId, reason: $reason) {
      id
      status
    }
  }
`;

export const SUSPEND_DRIVER = `
  mutation SuspendDriver($driverId: ID!, $reason: String!) {
    suspendDriver(driverId: $driverId, reason: $reason) {
      id
      status
    }
  }
`;

export const REACTIVATE_DRIVER = `
  mutation ReactivateDriver($driverId: ID!) {
    reactivateDriver(driverId: $driverId) {
      id
      status
    }
  }
`;

export const UPDATE_PRICING_RULES = `
  mutation UpdatePricingRules($input: PricingRulesInput!) {
    updatePricingRules(input: $input) {
      baseFare
      distanceRate
      timeRate
      minimumFare
    }
  }
`;

export const UPDATE_VEHICLE_STATUS = `
  mutation UpdateVehicleStatus($input: UpdateVehicleStatusInput!) {
    updateVehicleStatus(input: $input) {
      success
      message
    }
  }
`;
